import React from 'react';
import { useHistory } from 'react-router-dom';
import { parse } from '../../../util/urlHelpers';
import { constructQueryParamName } from '../../../util/search';
import RangeFilterPlain from './shared/RangeFilterPlain/RangeFilterPlain';

import css from './SearchPageStyles.module.css';

const SEARCH_PARAM = constructQueryParamName('length', 'public');

const LoaFilter = props => {
  const history = useHistory();
  const { location } = history;

  const currentQueryParams = parse(location?.search);

  return (
    <div className={css.row}>
      <RangeFilterPlain
        className={css.beamFilter}
        id="beamFilter"
        queryParamNames={SEARCH_PARAM}
        initialValues={{ [SEARCH_PARAM]: currentQueryParams[SEARCH_PARAM] }}
        min={0}
        step={1}
        max={100}
        unit="m"
        presets={[[0, 7], [7, 10], [10, 15], [15, 100]]}
        liveEdit={true}
        {...props}
      />
    </div>
  );
};

export default LoaFilter;
